'use strict';

// theme getter
var _require = require('./util'),
    get = _require.get;

module.exports = function (keys, fallback) {
  return function (props) {
    return get(props.theme, keys, fallback);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/theme.js
// module id = 68
// module chunks = 35783957827783 114276838955818 182246549230831